import { ColorPicker as ColorPickerPrimitive } from '@ark-ui/react/color-picker'
import { SVGProps } from 'react'

const IconEyeDropper = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={16}
		height={16}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M2.96 10.154 1.884 11.23a2.04 2.04 0 0 0-.516 2.014l-1.08 1.081a.981.981 0 1 0 1.387 1.388l1.08-1.081a2.04 2.04 0 0 0 2.015-.516l3.962-3.962zM7.504 5.61 3.897 9.218H9.67l.72-.72zm5.179 1.098-.252-.252 2.995-2.996a1.96 1.96 0 0 0 0-2.772l-.114-.114a1.96 1.96 0 0 0-2.771 0L9.545 3.57l-.253-.253a.974.974 0 0 0-1.378 1.378l3.391 3.391a.974.974 0 0 0 1.378-1.378"
			fill="currentColor"
		/>
	</svg>
)

export const ButtonEyeDropper = () => (
	<ColorPickerPrimitive.EyeDropperTrigger asChild>
		<button
			aria-label="Pick a color"
			className="flex size-10 items-center justify-center rounded-full border border-border-grey text-dark-grey transition hover:text-blue"
		>
			<IconEyeDropper />
		</button>
	</ColorPickerPrimitive.EyeDropperTrigger>
)
